import { Routes } from "@angular/router";
import { UserSuperAdminGuard } from "./guards/user-superadmin.guard";

import { SuperAdminLayoutComponent } from "./layouts/superadmin/superadmin-layout.component";
import { PublicLayoutComponent } from "./layouts/public/public-layout.component";
import { NopagefoundComponent } from "./pages/nopagefound/nopagefound.component";
import { AdminLayoutComponent } from "./layouts/admin/admin-layout.component";
import { NoAdminLayoutComponent } from "./layouts/noadmin/noadmin-layout.component";
import { UserNoAdminGuard } from "./guards/user-noadmin.guard";
import { SystemModule } from "./components/system/system.module";

export const AppRoutes: Routes = [
  { path: "", redirectTo: "public/login", pathMatch: "full" },

  // redirect superadmin
  {
    path: "superadmin-panel",
    redirectTo: "superadmin-panel/dashboard-superadmin",
    pathMatch: "full",
  },
  {
    path: "superadmin-panel/settings",
    redirectTo: "superadmin-panel/settings/profile",
    pathMatch: "full",
  },
  // redirect admin
  {
    path: "admin-panel",
    redirectTo: "admin-panel/dashboard",
    pathMatch: "full",
  },
  // Legacy URL: no client-panel route tree; client admins use admin-panel (see login.component).
  {
    path: "client-panel/dashboard",
    redirectTo: "admin-panel/dashboard",
    pathMatch: "full",
  },
  {
    path: "client-panel",
    redirectTo: "admin-panel/dashboard",
    pathMatch: "full",
  },
  // redirect noadmin
  /*  {
    path: "noadmin-panel",
    redirectTo: "noadmin-panel/dashboard",
    pathMatch: "full",
  }, */
  /*  {
    path: "noadmin-panel/administration",
    redirectTo: "noadmin-panel/administration/people",
    pathMatch: "full",
  }, */

  //Public
  {
    path: "public",
    component: PublicLayoutComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/pages.module").then((x) => x.PagesModule),
      },
    ],
  },

  //SuperAdmin
  {
    path: "superadmin-panel",
    component: SuperAdminLayoutComponent,
    canActivate: [UserSuperAdminGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./components/dashboard/dashboard.module").then(
            (x) => x.DashboardModule
          ),
      },

      {
        path: "",
        loadChildren: () =>
          import("./components/superadmin/superadmin.module").then(
            (x) => x.SuperAdminModule
          ),
      },

      {
        path: "settings",
        loadChildren: () =>
          import("./components/settings/settings.module").then(
            (x) => x.SettingsModule
          ),
      },

      {
        path: "master-clusters",
        loadChildren: () =>
          import(
            "./components/superadmin/master-clusters/masterclusters.module"
          ).then((x) => x.MasterclustersModule),
      },
    ],
  },
  //Admin
  {
    path: "admin-panel",
    canActivate: [UserNoAdminGuard],
    component: AdminLayoutComponent,
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./components/dashboard/dashboard.module").then(
            (x) => x.DashboardModule
          ),
      },
      {
        path: "administration",
        loadChildren: () =>
          import("./components/administration/administration.module").then(
            (x) => x.AdministrationModule
          ),
      },
      {
        path: "videos",
        loadChildren: () =>
          import("./components/videos/videos.module").then(
            (x) => x.VideosModule
          ),
      },
      {
        path: "incidents",
        loadChildren: () =>
          import("./components/incidents/incidents.module").then(
            (x) => x.IncidentsModule
          ),
      },
      {
        path: "collections",
        loadChildren: () =>
          import("./components/collections/collection.module").then(
            (x) => x.CollectionsModule
          ),
      },
      {
        path: "devices",
        loadChildren: () =>
          import("./components/devices/devices.module").then(
            (x) => x.DeviceModule
          ),
      },
      {
        path: "reports",
        loadChildren: () =>
          import("./components/reports/reports.module").then(
            (x) => x.ReportsModule
          ),
      },
      {
        path: "notifications",
        loadChildren: () =>
          import("./components/notifications/notifications.module").then(
            (x) => x.NotificationModule
          ),
      },
      {
        path: "tactical-map",
        loadChildren: () =>
          import("./components/tactical-map/tactical-map.module").then(
            (x) => x.TacticalMapModule
          ),
      },
      {
        path: "system",
        loadChildren: () =>
          import("./components/system/system.module").then(
            (x) => x.SystemModule
          ),
      },
    ],
  },

  //NoAdmin
  {
    path: "noadmin-panel",
    component: NoAdminLayoutComponent,
    // canActivate: [UserNoAdminGuard],
    children: [
      {
        path: "dashboard",
        loadChildren: () =>
          import("./components/dashboard/dashboard.module").then(
            (x) => x.DashboardModule
          ),
      },
      {
        path: "administration",
        loadChildren: () =>
          import("./components/administration/administration.module").then(
            (x) => x.AdministrationModule
          ),
      },
      {
        path: "videos",
        loadChildren: () =>
          import("./components/videos/videos.module").then(
            (x) => x.VideosModule
          ),
      },
      {
        path: "incidents",
        loadChildren: () =>
          import("./components/incidents/incidents.module").then(
            (x) => x.IncidentsModule
          ),
      },
      {
        path: "collections",
        loadChildren: () =>
          import("./components/collections/collection.module").then(
            (x) => x.CollectionsModule
          ),
      },
      {
        path: "devices",
        loadChildren: () =>
          import("./components/devices/devices.module").then(
            (x) => x.DeviceModule
          ),
      },
      {
        path: "reports",
        loadChildren: () =>
          import("./components/reports/reports.module").then(
            (x) => x.ReportsModule
          ),
      },
      {
        path: "notifications",
        loadChildren: () =>
          import("./components/notifications/notifications.module").then(
            (x) => x.NotificationModule
          ),
      },
      {
        path: "tactical-map",
        loadChildren: () =>
          import("./components/tactical-map/tactical-map.module").then(
            (x) => x.TacticalMapModule
          ),
      },
      {
        path: "system",
        loadChildren: () =>
          import("./components/system/system.module").then(
            (x) => x.SystemModule
          ),
      },
    ],
  },

  { path: "**", component: NopagefoundComponent },
];
